import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import TrackWrapper, {
  type TrackWrapperProps
} from '~/components/common/TrackWrapper';

export const LinkCardTrackWrapper = createComponent<
  ElementWithProps<TrackWrapperProps>
>(TrackWrapper, () => ({
  className: 'flex h-full w-full flex-col gap-2xl overflow-hidden p-2xl'
}));

export const HeaderWrapper = createComponent('div', {
  className: 'flex items-center justify-between'
});

export const Header = createComponent('h3', {
  className: 'text-text-strong t-heading-md md:t-heading-lg'
});

export const LinkCardsContainer = createComponent('div', {
  className: 'grid h-full w-full content-start gap-lg'
});

export const LinkCardLoadingContainer = createComponent('div', {
  className:
    'flex h-full flex-col gap-2xl rounded-md bg-background-default p-2xl'
});

export const DividerLine = createComponent('div', {
  className: 'w-full border-b border-border-subtle'
});
